import { queryOptions } from '@tanstack/react-query';
import { BondQuantityType, Order, PriceType } from '@orbis-systems/orbis-api-middleware';
import { SuccessClientResponse } from '@orbis-systems/orbis-api-clients';
import { orbis } from '../api';

export type OrdersListingForBranchResponse = SuccessClientResponse<Order[]>;

export interface OrdersListingForBranchQueryParams {
    type: string;
    query?: {
        /** Return bond pricing type in `Percentage|Decimal` (optional) */
        bondPriceType?: PriceType;
        loadQuotes?: boolean;
        symbol?: string;
        bondQuantityType?: BondQuantityType;
    };
}

export const ordersQueries = {
    all: () => queryOptions({ queryKey: ['orders'] }),
    listingForBranch: (params: OrdersListingForBranchQueryParams) =>
        queryOptions<OrdersListingForBranchResponse>({
            queryKey: [...ordersQueries.all().queryKey, 'listingForBranch', params],
            queryFn: () => orbis.orders.listingForBranch(params.type, params.query),
        }),
};
